module.exports = __webpack_public_path__ + "images/assets/a63090315efa238e7656a40a3c7c8b96.svg";